import React from "react";
import { formatTableCellValue } from "../utils";

const MainTable = ({
  segmentTitle,
  error,
  monthColumns,
  rows,
  selectedCategory,
  handleRowClick,
}) => {
  return (
    <div className="rounded-2xl border border-slate-200 bg-white shadow-sm">
      <div className="border-b border-slate-200 px-4 py-4">
        <p className="text-sm font-medium text-slate-400">
          Home / Insights / EDA Dashboard Detail / {segmentTitle} - Fixed Cost
          Optimization
        </p>
        <h2 className="mt-2 text-lg font-semibold text-slate-800">
          Nature of cost by BP category - Monthly cumulative actuals (Rs Cr)
        </h2>
      </div>

      {error && (
        <div className="border-b border-red-100 bg-red-50 px-4 py-3 text-sm text-red-600">
          {error}
        </div>
      )}

      <div className="overflow-x-auto">
        <table className="min-w-full text-sm text-slate-700">
          <thead className="bg-slate-50 text-left text-xs font-semibold uppercase tracking-[0.08em] text-slate-500">
            <tr>
              <th className="px-4 py-3">#</th>
              <th className="px-4 py-3">BP Category (Nature of Cost)</th>
              <th className="px-4 py-3 text-right">Baseline/yr</th>
              <th className="px-4 py-3 text-right">Target/yr</th>
              <th className="px-4 py-3 text-right">Bl/mo</th>
              <th className="px-4 py-3 text-right">Tg/mo</th>
              {monthColumns.map((month) => (
                <th key={month.key} className="px-4 py-3 text-right">
                  {month.title}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.length === 0 ? (
              <tr>
                <td
                  colSpan={6 + monthColumns.length}
                  className="px-4 py-8 text-center text-sm text-slate-400"
                >
                  No summary rows available for this segment.
                </td>
              </tr>
            ) : (
              rows.map((row, index) => {
                const isTotalRow =
                  String(row?.["Category as per BP"] || "")
                    .trim()
                    .toLowerCase() === "total";

                return (
                  <tr
                    key={`${row?.["Category as per BP"] || "row"}-${index}`}
                    onClick={() =>
                      !isTotalRow && handleRowClick(row["Category as per BP"])
                    }
                    className={`border-t border-slate-100 ${
                      isTotalRow
                        ? "bg-slate-50 font-semibold"
                        : "cursor-pointer transition-colors hover:bg-slate-50"
                    } ${
                      selectedCategory === row["Category as per BP"] &&
                      !isTotalRow
                        ? "bg-blue-50 hover:bg-blue-100"
                        : ""
                    }`}
                  >
                    <td className="px-4 py-3 text-slate-400">
                      {isTotalRow ? "" : index + 1}
                    </td>
                    <td className="px-4 py-3">
                      {isTotalRow
                        ? "Total Cost"
                        : row?.["Category as per BP"] || "-"}
                    </td>
                    <td className="px-4 py-3 text-right font-mono">
                      {formatTableCellValue(
                        row?.Baseline_PerYear,
                        !isTotalRow
                      )}
                    </td>
                    <td className="px-4 py-3 text-right font-mono">
                      {formatTableCellValue(row?.Target_PerYear, !isTotalRow)}
                    </td>
                    <td className="px-4 py-3 text-right font-mono">
                      {formatTableCellValue(
                        row?.Baseline_PerMonth,
                        !isTotalRow
                      )}
                    </td>
                    <td className="px-4 py-3 text-right font-mono">
                      {formatTableCellValue(
                        row?.Target_PerMonth,
                        !isTotalRow
                      )}
                    </td>
                    {monthColumns.map((month) => {
                      const value = Number(row[month.key] || 0);

                      return (
                        <td
                          key={month.key}
                          className={`px-4 py-3 text-right font-mono ${
                            value > 0
                              ? "text-emerald-600"
                              : value < 0
                              ? "text-rose-600"
                              : "text-slate-500"
                          }`}
                        >
                          {formatTableCellValue(value)}
                        </td>
                      );
                    })}
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default MainTable;
